// src/pages/ChangePassword.js
import React, { useState } from 'react';
import axios from 'axios';

const ChangePassword = () => {
  const [phone, setPhone] = useState('');
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [message, setMessage] = useState('');

  const handleChangePassword = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`https://learningplatformbc-production.up.railway.app/api/auth/change-password`, {
        phone,
        oldPassword,
        newPassword
      });
      setMessage(response.data.message);
    } catch (error) {
      console.error("Error changing password:", error); // Log the entire error

      setMessage(error.response?.data?.message || 'Error changing password');
    }
  };

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="card p-4">
            <h3 className="card-title mb-3">Change Password</h3>
            {message && <div className="alert alert-info">{message}</div>}
            <form onSubmit={handleChangePassword}>
              <div className="form-group mb-3">
                <label htmlFor="phone">Phone Number</label>
                <input
                  type="text"
                  className="form-control"
                  id="phone"
                  placeholder="Enter your phone number"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  required
                />
              </div>
              <div className="form-group mb-3">
                <label htmlFor="oldPassword">Old Password</label>
                <input
                  type="password" 
                  className="form-control"
                  id="oldPassword"
                  placeholder="Enter your old password"
                  value={oldPassword}
                  onChange={(e) => setOldPassword(e.target.value)}
                  required
                />
              </div>
              <div className="form-group mb-3">
                <label htmlFor="newPassword">New Password</label>
                <input
                  type="password"
                  className="form-control"
                  id="newPassword"
                  placeholder="Enter your new password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  required
                />
              </div>
              <button type="submit" className="btn btn-primary btn-block">Change Password</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
